import Alert from "../../../Common/Alert";
import API from "../../../Common/Network/API";
import { isLoaded, isLoading } from "../actions";

//Delete Project/Epic
export async function deleteEpic(dispatch,getUser,ideaId,handleClose,handleModalClose, PROJECT_DELETE) {
    dispatch(isLoading());
    try {
      var response = await API.post("manage_epics.php", {
        corp: getUser.corp,
        idea_id: ideaId,
        action: "delete",
        empId:getUser.empId,
        projectId:getUser.projectId
      },{},false);
      if(response.status === 'True') {
        Alert("success", PROJECT_DELETE)
        handleClose()
      }else if( response.status === "false")
      {
        handleModalClose()
        Alert("warning",response.message)
      }
      // handleClose()
    } catch (error) {
      Alert('error',error.message);
      handleClose()
    }
    dispatch(isLoaded());
  }